export const COMPANY = {
  name: '株式会社クリアコーポレーション',
  nameEn: 'Clear Corporation',
  zip: '〒451-0013',
  address: '愛知県名古屋市西区江向町五丁目15番地1',
  tel: '052-325-5812',
  telHref: 'tel:052-325-5812',
  hours: '9:00〜17:00',
  license: '愛知県知事（1）第25984号',
  licenseValidity: '令和7年3月18日〜令和12年3月17日',
  representative: '代表取締役 溝口 富久',
  area: '全国相談OK（名古屋16区に強み）',
};

// Alias for compatibility
export const COMPANY_INFO = {
  name: COMPANY.name,
  address: `${COMPANY.zip} ${COMPANY.address}`,
  phone: COMPANY.tel,
  businessHours: COMPANY.hours,
  licenseNumber: COMPANY.license,
  licensePeriod: COMPANY.licenseValidity,
  representative: COMPANY.representative,
};

export const AI_SATEI_URL =
  'https://www.aisatei.com/?id=f62efdb3-5aad-4407-9c91-174e16bd0945';

export const AT_HOME_URL = 'https://asp.athome.jp/074279/shubetsu/baibai/shumoku';

export const NAGOYA_16_WARDS = [
  '千種区', '東区', '北区', '西区',
  '中村区', '中区', '昭和区', '瑞穂区',
  '熱田区', '中川区', '港区', '南区',
  '守山区', '緑区', '名東区', '天白区',
];
